import { withStyles } from '@material-ui/core';

import styles from '../SingleReceiptForm/styles';
import SingleReceiptItemsCount from './component';

export default withStyles(styles)(SingleReceiptItemsCount);
